/*
 app dependencies
 - var body

 lib dependencies
*/

const scSearch = (function($)
{
    const   _showTriggers = document.querySelectorAll('.js-show-search'),
            _hideTriggers = document.querySelectorAll('.js-hide-search'),
            _searchField = document.querySelector('.js-header-search-input'),
            _bodyToggleClass = 'show-header-search';

	//module functions
	function init()
	{
		for (const trigger of _showTriggers)
        {
            trigger.addEventListener('click', function(e)
            {
                e.preventDefault();

                if (window.matchMedia !== undefined)
                {
                    if (window.matchMedia("(min-width: 992px)").matches)
                    {
                        showHeaderSearch();
                    }
                    else
                    {
                        scMobileMenu.showMobileMenu(true);
                    }
                }
                else
                {
                    //probably IE Mobile
                    scMobileMenu.showMobileMenu(true);
                }
            });
        }

        for (const trigger of _hideTriggers)
        {
            trigger.addEventListener('click', function(e)
            {
                e.preventDefault();
                hideHeaderSearch();
            });
        }
	}

    function showHeaderSearch()
    {
        body.classList.add(_bodyToggleClass);
        _searchField.focus();
    }
    function hideHeaderSearch()
    {
        body.classList.remove(_bodyToggleClass);
    }

	//reveal public vars and functions
	return {
		//vars

		//functions
		init,
        showHeaderSearch,
        hideHeaderSearch
	};

})(jQuery);
